import React from 'react';
import styled from 'styled-components';
import { Steps } from 'tdesign-react';

const { StepItem } = Steps;

const steps = [
  '步骤一:下拉制品前执行',
  '步骤二:下拉制品',
  '步骤三:下拉制品后执行',
  '步骤四:软链接到新版本',
  '步骤五:启动前执行',
  '步骤六:启动后执行',
];

export default function ConfigSteps() {
  return (
    <Root>
      <Title>执行步骤</Title>
      <Steps defaultCurrent={null} readonly layout='vertical'>
        {steps.map((item) => (
          <StepItem value={item} key={item} title={item} />
        ))}
      </Steps>
    </Root>
  );
}

const Root = styled.div`
  padding: 16px 10px 0 20px;
  width: 230px;
  box-sizing: border-box;
  .t-steps {
    .t-steps-item__icon {
      margin-right: 4px;
      .t-steps-item__icon--number {
        border-color: transparent;
        background-color: transparent;
      }
    }
    .t-steps-item--clickable {
      cursor: default;
    }
    .t-steps-item__icon--number {
      font-size: 13px;
      color: var(--td-text-color-primary);
    }
    .t-steps-item__title {
      font-size: 13px;
      color: var(--td-text-color-primary);
      font-weight: normal;
      margin-bottom: 0;
    }
    .t-steps-item--process {
      .t-steps-item__icon--number {
        font-weight: normal;
      }
    }
    .t-steps-item__description {
      font-size: 12px;
    }
  }
`;

const Title = styled.div`
  color: var(--td-text-color-primary);
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 18px;
`;
